<!-- COOKIE ALERT - [START] -->
<div
  class="sfy_cookie-alert"
  *ngIf="cookieStep > 0 && (clientId === 'bcrgeorgeclient' || clientId === 'Dateio' || clientId === 'MMP')"
  [ngClass]="{ scaleWrapper: showText || showText2 }"
>
  <div class="sfy_cookie-alert-wrapper">
    <div class="row">
      <!-- COOKIE STEPS - Conditioned [START]-->
      <div class="col-xs-12">
        <!-- Step[1] -->
        <div *ngIf="cookieStep === 1" class="sfy_cookie-alert-step1">
          <div class="sfy_cookie-text-wrapper">
            <h3>
              <svg class="ico-cookie-xl g-image-48" aria-hidden="true" focusable="false" viewBox="0 0 512 512">
                <path
                  d="m371 272c-4 10-14 16-24 16-15 0-27-12-27-27 0-10 6-20 16-24-7-10-11-22-14-34-1 0-1 0-2 0-47 0-85-38-85-85-39 2-74 18-100 43 8 3 14 11 14 20 0 12-9 22-21 22-8 0-15-4-18-11-16 25-25 54-25 85 0 89 72 160 160 160 86 0 156-67 160-151-12-3-24-7-34-14z m-114-164c-1 3-1 6-1 9 0 36 29 64 64 64 3 0 6 0 10 0 6-1 11 3 12 9 4 40 35 72 75 76 6 1 10 5 10 11 0 100-82 182-182 182-100 0-181-82-181-182 0-100 81-181 181-181 8 0 13 6 12 12z m-118 191c11 0 21 9 21 21 0 12-10 21-21 21-12 0-22-9-22-21 0-12 10-21 22-21z m133 64c15 0 27 12 27 26 0 15-12 27-27 27-15 0-27-12-27-27 0-14 12-26 27-26z m-64-150c15 0 27 12 27 27 0 15-12 27-27 27-15 0-27-12-27-27 0-15 12-27 27-27z m123-149c11 0 21 10 21 21 0 12-10 22-21 22-12 0-22-10-22-22 0-11 10-21 22-21z m10 64c6 0 11 5 11 11 0 6-5 10-11 10-6 0-10-4-10-10 0-6 4-11 10-11z m64-43c6 0 11 5 11 11 0 6-5 11-11 11-6 0-10-5-10-11 0-6 4-11 10-11z m11 64c12 0 21 10 21 22 0 11-9 21-21 21-12 0-21-10-21-21 0-12 9-22 21-22z"
                ></path>
              </svg>
              {{ clientId + '.COOKIE_TEXT_1' | translate }}
              <a
                class="sfy_btn-showMore"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
                (click)="toggleText()"
              >
              </a>
            </h3>
          </div>
          <div id="collapseOne" class="collapse sfy_cookie-text-more-wrapper p_lr_10" aria-labelledby="headingOne">
            <div class="card-body">
              <p [innerHTML]="clientId + '.COOKIE_MORE_INFO_1' | translate"></p>
            </div>
          </div>
          <div class="bcr_cookies-actions">
            <button class="btn btn-lg sfy_btn-orange m_r_15" (click)="acceptAllCookieSettings()">
              {{ clientId + '.COOKIE_ACCEPT' | translate }}
            </button>
            <button class="btn btn-lg sfy_btn-white-outline" (click)="changeCookieSettings()">
              {{ clientId + '.COOKIE_CHANGE' | translate }}
            </button>
          </div>
        </div>

        <!-- Step[2] -->
        <div *ngIf="cookieStep === 2">
          <div class="sfy_cookie-text-wrapper">
            <h3>
              <svg class="ico-cookie-xl g-image-48" aria-hidden="true" focusable="false" viewBox="0 0 512 512">
                <path
                  d="m371 272c-4 10-14 16-24 16-15 0-27-12-27-27 0-10 6-20 16-24-7-10-11-22-14-34-1 0-1 0-2 0-47 0-85-38-85-85-39 2-74 18-100 43 8 3 14 11 14 20 0 12-9 22-21 22-8 0-15-4-18-11-16 25-25 54-25 85 0 89 72 160 160 160 86 0 156-67 160-151-12-3-24-7-34-14z m-114-164c-1 3-1 6-1 9 0 36 29 64 64 64 3 0 6 0 10 0 6-1 11 3 12 9 4 40 35 72 75 76 6 1 10 5 10 11 0 100-82 182-182 182-100 0-181-82-181-182 0-100 81-181 181-181 8 0 13 6 12 12z m-118 191c11 0 21 9 21 21 0 12-10 21-21 21-12 0-22-9-22-21 0-12 10-21 22-21z m133 64c15 0 27 12 27 26 0 15-12 27-27 27-15 0-27-12-27-27 0-14 12-26 27-26z m-64-150c15 0 27 12 27 27 0 15-12 27-27 27-15 0-27-12-27-27 0-15 12-27 27-27z m123-149c11 0 21 10 21 21 0 12-10 22-21 22-12 0-22-10-22-22 0-11 10-21 22-21z m10 64c6 0 11 5 11 11 0 6-5 10-11 10-6 0-10-4-10-10 0-6 4-11 10-11z m64-43c6 0 11 5 11 11 0 6-5 11-11 11-6 0-10-5-10-11 0-6 4-11 10-11z m11 64c12 0 21 10 21 22 0 11-9 21-21 21-12 0-21-10-21-21 0-12 9-22 21-22z"
                ></path>
              </svg>
              {{ clientId + '.COOKIE_TEXT_2' | translate }}
              <a
                class="sfy_btn-showMore"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="true"
                aria-controls="collapseTwo"
                (click)="toggleText2()"
              >
                <svg *ngIf="!showText2" class="ico-arrow-expand" aria-hidden="true" focusable="false">
                  <use href="#ico-arrow-expand" xlink:href="#ico-arrow-expand" />
                </svg>
                <svg *ngIf="showText2" class="ico-arrow-collapse" aria-hidden="true" focusable="false">
                  <use href="#ico-arrow-collapse" xlink:href="#ico-arrow-collapse" />
                </svg>
              </a>
            </h3>
          </div>

          <div class="bcr_cookies-actions">
            <button class="btn btn-lg sfy_btn-orange m_b_20" (click)="saveCookieSettings()">
              {{ clientId + '.COOKIE_SAVE' | translate }}
            </button>
          </div>

          <div id="collapseTwo" class="collapse sfy_cookie-text-more-wrapper p_lr_10" aria-labelledby="headingTwo">
            <div class="card-body">
              <p [innerHTML]="clientId + '.COOKIE_MORE_INFO_2' | translate"></p>
            </div>
          </div>

          <div class="bcr_cookies-options p_lr_10 m_t_20">
            <label class="sfy_control sfy_control-checkbox" for="features"
              >{{ clientId + '.COOKIE_CHECKBOX_1' | translate }}
              <input type="checkbox" id="features" disabled checked />
              <div class="sfy_control-indicator"></div>
            </label>

            <label class="sfy_control sfy_control-checkbox" for="promotions"
              >{{ clientId + '.COOKIE_CHECKBOX_2' | translate }}
              <input type="checkbox" id="promotions" (click)="clickCheckBoxPromotions()" />
              <div class="sfy_control-indicator"></div>
            </label>

            <label class="sfy_control sfy_control-checkbox" for="statistics"
              >{{ clientId + '.COOKIE_CHECKBOX_3' | translate }}
              <input type="checkbox" id="statistics" (click)="clickCheckBoxStatistics()" />
              <div class="sfy_control-indicator"></div>
            </label>
          </div>
        </div>
      </div>
      <!-- COOKIE STEPS - Conditioned [END]-->
    </div>
  </div>
</div>
<!-- COOKIE ALERT - [END] -->

<div
  class="sfy_full-wrapper-login sfy_display-flex"
  id="sfy_full-wrapper"
  *ngIf="
    ((clientId === 'Dateio' || clientId === 'MMP') && os === 'Windows') || (clientId !== 'Dateio' && clientId !== 'MMP')
  "
>
  <!-- sfy_left-wrapper -->
  <div
    class="col-12 col-lg-4 sfy_client-{{ clientId }}-rw sfy_p-relative sfy_client"
    [ngClass]="{
      'tpp-left-wrapper': clientIsTpp || clientId === 'signClient' || clientGuardianRole,
      'sfy_client-signClient-rw': clientIsTpp || clientId === 'signClient',
      scroll_down: clientId === 'bcrgeorgeclient' && !isMobileWidth
    }"
  >
    <!-- Login widget  -->
    <div class="sfy_login-wrapper sfy_p-relative">
      <div class="sfy_form-wrapper {{ clientId }}">
        <router-outlet></router-outlet>
      </div>

      <!-- Footer section -->
      <gla-full-slided-page [showPage]="fullFooterOpened">
        <span body class="footer-menu">
          <span (click)="openFullPage()" class="icon icon-error-default"></span>
          <ul id="links" class="nav">
            <li class="nav-item">
              <a
                [href]="(clientIsTpp ? 'signClient' : clientId) + '.TERMS_CONDS_URL' | translate"
                class="nav-link"
                target="_blank"
                rel="noopener"
                >{{ (clientIsTpp ? 'signClient' : clientId) + '.TERMS_CONDS_TEXT' | translate }}</a
              >
            </li>
            <li class="nav-item">
              <a
                *ngIf="clientId === 'docheaven' || clientId === 'docheavenMobile'"
                [href]="clientId + '.CONTACT_URL' | translate"
                class="nav-link"
                target="_blank"
                rel="noopener"
                >{{ clientId + '.CONTACT_TEXT_DOCHEAVEN' | translate }}</a
              >
            </li>
            <li class="nav-item" *ngIf="clientId !== 'docheaven' && clientId !== 'docheavenMobile'">
              <a
                [href]="(clientIsTpp ? 'signClient' : clientId) + '.CONTACT_URL' | translate"
                class="nav-link"
                target="_blank"
                rel="noopener"
                >{{ (clientIsTpp ? 'signClient' : clientId) + '.CONTACT_TEXT' | translate }}</a
              >
            </li>
          </ul>
        </span>
      </gla-full-slided-page>
      <span (click)="openFullPage()" class="icon icon-menu-default navbar-toggler-icon show-460"></span>
      <footer class="d-flex justify-content-center justify-content-between mt-auto py-3 px-3 px-lg-5">
        <a [href]="clientId + '.LANDING_PAGE' | translate" target="_blank" rel="noopener noreferrer" class="logo-link">
          <img class="img-fluid" alt="Bcr Logo" src="assets/svg/bcr-logo-white.svg"
        /></a>
        <ul id="links" class="nav hide-460 d-flex align-items-center justify-content-end">
          <li class="nav-item">
            <a
              [href]="(clientIsTpp ? 'signClient' : clientId) + '.TERMS_CONDS_URL' | translate"
              class="nav-link px-2 py-2 text-center"
              target="_blank"
              rel="noopener"
              >{{ (clientIsTpp ? 'signClient' : clientId) + '.TERMS_CONDS_TEXT' | translate }}</a
            >
          </li>
          <li class="nav-item" *ngIf="clientId === 'docheaven' || clientId === 'docheavenMobile'">
            <a
              [href]="clientId + '.CONTACT_URL' | translate"
              class="nav-link px-2 py-2 text-center"
              target="_blank"
              rel="noopener"
              >{{ clientId + '.CONTACT_TEXT_DOCHEAVEN' | translate }}</a
            >
          </li>
          <li class="nav-item" *ngIf="clientId !== 'docheaven' && clientId !== 'docheavenMobile'">
            <a
              [href]="(clientIsTpp ? 'signClient' : clientId) + '.CONTACT_URL' | translate"
              class="nav-link px-2 py-2 text-center"
              target="_blank"
              rel="noopener"
              >{{ (clientIsTpp ? 'signClient' : clientId) + '.CONTACT_TEXT' | translate }}</a
            >
          </li>
        </ul>
      </footer>
    </div>
  </div>
  <!-- sfy_right-wrapper -->
  <div
    class="col-lg-8 d-none d-lg-flex sfy_client-{{ clientId }} sfy_p-relative sfy_display-flex sfy_client"
    [ngClass]="{
      'sfy_client-bcrgeorgeclient': clientId === 'bcrgeorgeclient' || clientIsDefault,
      'sfy_client-isTpp': clientId === 'signClient' || clientIsTpp || clientGuardianRole
    }"
  >
    <div class="sfy_hero sfy_df-ac d-none d-md-flex" *ngIf="clientId === 'bcrgeorgeclient' || clientIsDefault">
      <div class="hero-texts">
        <img src="assets/images/logoSvg.svg" alt="George Business Logo" />
        <h2 class="animated fadeInUp" [innerHTML]="clientId + '.CLIENT_GBIZ' | translate"></h2>
      </div>
    </div>
  </div>

  <div
    class="sfy_full-wrapper-info-pic"
    [ngClass]="{ ios: os === 'iOS', android: os === 'Android' }"
    *ngIf="(clientId === 'Dateio' || clientId === 'MMP') && os !== 'Windows'"
  >
    <div class="sfy_language" style="display: flex" (click)="changeLanguage()">
      <span class="lang">
        {{ language == 'en-US' ? 'RO' : 'EN' }}
      </span>
      <img [src]="clientId + '.NEW_LANGUAGE_ICON' | translate" alt="logo-george" style="width: 24px; height: 18px" />
    </div>
    <div class="sfy_pic-info-title">
      <h1>{{ clientId + '.PIC_INFO_TITLE' | translate }}</h1>
    </div>

    <div class="sfy_pic-info-details">
      <p>{{ clientId + '.PIC_INFO_DETAILS_1' | translate }}</p>
    </div>

    <div class="sfy_pic-store-container" *ngIf="os === 'Android'">
      <div (click)="openPlayStore()">
        <img [src]="clientId + '.ANDROID_STORE_IMG' | translate" alt="googleplay-img" />
      </div>
    </div>

    <div class="sfy_pic-store-container" *ngIf="os === 'iOS'">
      <div (click)="openPlayStore()">
        <img [src]="clientId + '.iOS_STORE_IMG' | translate" alt="googleplay-img" />
      </div>
    </div>

    <div class="sfy_pic-info-details">
      <p [innerHTML]="clientId + '.PIC_INFO_DETAILS_2' | translate"></p>
    </div>
  </div>
  <app-loading></app-loading>
</div>
